module.exports = __webpack_public_path__ + "img/Nikolaos-Karaiskakis.f2fd0737.jpg";